import React, { forwardRef } from "react";
import icons from "../../../../../assets/images/icons";
import { useEscapeClose } from "../../../../../common/hooks/useEscapeClose";
import styles from "./ChatRoomMoreModal.module.scss";

/**
 * 채팅방 상세 …(더보기) 모달 — UI만 담당.
 * blockedByMe 상태에 따라 onBlock / onUnblock 직접 호출.
 */
const ChatRoomMoreModal = forwardRef(function ChatRoomMoreModal(
  {
    className = "",
    style,
    otherUserId = "",
    blockedByMe,
    onReport,
    onBlock,
    onUnblock,
    onNotification,
    onLeave,
    onClose,
  },
  ref
) {
  useEscapeClose(onClose, true);

  const blockLabel = blockedByMe ? "차단 해제" : "차단하기";
  const blockDisabled = !otherUserId;

  const handleBlockRowClick = () => {
    if (blockDisabled) return;
    if (blockedByMe) onUnblock?.();
    else onBlock?.();
    onClose?.();
  };

  return (
    <div
      ref={ref}
      className={`${styles.root} ${className}`.trim()}
      style={style}
      role="dialog"
      aria-modal="true"
      aria-label="대화 더보기 메뉴"
      data-node-id="40004313:35659"
    >
      <div className={styles.container} data-node-id="40004313:35660">
        <div className={styles.contents}>
          <button
            type="button"
            className={styles.cell}
            onClick={() => {
              onReport?.();
              onClose?.();
            }}
            data-node-id="40004313:35663"
          >
            <span className={styles.label} data-node-id="40004313:35677">
              신고하기
            </span>
            <span className={styles.trailing} data-node-id="40004313:35681">
              {icons.messager?.circleExclamation && (
                <img
                  src={icons.messager.circleExclamation}
                  alt=""
                  className={styles.trailingIcon}
                  width={20}
                  height={20}
                />
              )}
            </span>
          </button>
          <button
            type="button"
            className={styles.cell}
            disabled={blockDisabled}
            onClick={handleBlockRowClick}
            data-node-id="40004313:35685"
          >
            <span className={styles.label} data-node-id="40004313:35699">
              {blockLabel}
            </span>
            <span className={styles.trailing} data-node-id="40004313:35703">
              {icons.messager?.block && (
                <img
                  src={icons.messager.block}
                  alt=""
                  className={styles.trailingIcon}
                  width={20}
                  height={20}
                />
              )}
            </span>
          </button>
          <button
            type="button"
            className={`${styles.cell} ${styles.cellDanger}`}
            onClick={() => {
              onLeave?.();
              onClose?.();
            }}
            data-node-id="40004313:35730"
          >
            <span className={styles.label} data-node-id="40004313:35744">
              채팅방 나가기
            </span>
            <span className={styles.trailing} data-node-id="40004313:35748">
              {icons.messager?.leaveRed && (
                <img
                  src={icons.messager.leaveRed}
                  alt=""
                  className={styles.trailingIcon}
                  width={20}
                  height={20}
                />
              )}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
});

export default ChatRoomMoreModal;
